import type { KeyboardEvent } from 'react';
import { createContext, useContext } from 'react';
import type { PlaceSuggestion } from 'hooks/shared/useGoogleAddressAutocomplete';

export type AddressSearchFieldAutocompleteContextValue = {
  listboxId: string;
  suggestions: PlaceSuggestion[];
  suggestionsOpen: boolean;
  activeIndex: number;
  getOptionId: (index: number) => string;
  handleInputChange: (value: string) => void;
  handleKeyDown: (e: KeyboardEvent) => void;
  handleBlur: () => void;
  pickSuggestion: (suggestion: PlaceSuggestion) => void;
};

const AddressSearchFieldAutocompleteContext =
  createContext<AddressSearchFieldAutocompleteContextValue | null>(null);

export const AddressSearchFieldAutocompleteProvider =
  AddressSearchFieldAutocompleteContext.Provider;

export const useAddressSearchFieldAutocomplete =
  (): AddressSearchFieldAutocompleteContextValue => {
    const ctx = useContext(AddressSearchFieldAutocompleteContext);
    if (!ctx) {
      throw new Error(
        'useAddressSearchFieldAutocomplete must be used within AddressSearchFieldAutocompleteProvider (mount the provider in a parent that owns useGoogleAddressAutocomplete).',
      );
    }
    return ctx;
  };
